import { Stack } from '@mui/material';

export default function Container(props) {
  return <Stack alignItems="stretch" gap={1.5} {...props} />;
}
